module.exports = __webpack_public_path__ + "img/erath.bd04cfe8.webp";